import moment from "moment"

export function formatDate(date: string): string {
  const [days, hours] = date.split('T') as string[]
  const [year, month, day] = days.split('-')
  return day + '/' + month + '/' + year + ' ' + hours.split('.')[0]
}

function getDate(date: string) {
  const year = moment(new Date()).diff(moment(date), 'years')
  if (year > 0) return [year, 'anos']

  const month = moment(new Date()).diff(moment(date), 'months')
  if (month > 0) return [month, 'mês']

  const day = moment(new Date()).diff(moment(date), 'days')
  if (day > 0) return [day, 'dias']

  const hour = moment(new Date()).diff(moment(date), 'hours')
  if (hour > 0) return [hour, 'horas']

  const minute = moment(new Date()).diff(moment(date), 'minutes')
  if (minute > 0) return [minute, 'minutos']

  return [moment(new Date()).diff(moment(date), 'second'), 'segundos']
}


export function calculateDate(datetime: string, formatDate: boolean = true, fullText: boolean= true): number | string {
  const [date, type] = getDate(datetime)

  if (!formatDate) return date[0]

  switch (type) {
    case 'anos':
      if (!fullText) return date + ' a'
      return date > 0 ? date + ' anos' : date + 'ano'
    case 'mês':
      if (!fullText) return date + ' m'

      return date > 0 ? date + ' meses' : date + 'mês'
    case 'dias':
      if (!fullText) return date + ' d'

      return date > 0 ? date + ' dias' : date + 'dia'
    case 'horas':
      if (!fullText) return date + ' h'

      return date > 0 ? date + ' horas' : date + 'hora'
    case 'minutos':
      if (!fullText) return date + ' min'

      return date > 0 ? date + ' minutos' : date + 'minuto'
    case 'segundos':
      if (!fullText) return date + ' seg'

      return date > 0 ? date + ' segundos' : date + 'segundo'
  }
}

export function isDateWithinSevenDays(date: string): boolean {
  if (!date || date === "") return false;
  
  const currentDate = new Date();
  const targetDate = new Date(date);
  const sevenDaysLater = new Date(targetDate.getTime() + (7 * 24 * 60 * 60 * 1000));
  
  return currentDate <= sevenDaysLater;
}